import { WidgetExternalApplicationType } from '../../../../types/widget';
import { getDetails as getCecurityDetails } from '../applications/Cecurity';
import { getDetails as getDigipharmacieSSODetails } from '../applications/DigipharmacieSSO';
import { getDetails as getFinthesisDetails } from '../applications/Finthesis';
import { getDetails as getFinthesisSSODetails } from '../applications/FinthesisSSO';
import { getDetails as getGenericDetails } from '../applications/Generic';
import { getDetails as getMegDetails } from '../applications/Meg';
import { getDetails as getMegSSODetails } from '../applications/MegSSO';
import { getDetails as getMySilaeDetails } from '../applications/MySilae';
import { getDetails as getN2fDetails } from '../applications/N2f';
import { getDetails as getSilaeDetails } from '../applications/Silae';
import { getDetails as getSilaeSSODetails } from '../applications/SilaeSSO';
import { getDetails as getYoozDetails } from '../applications/Yooz';

const appTypeDetailsFunctionMapper = new Map([
	['generic', getGenericDetails],
	['cecurity', getCecurityDetails],
	['digipharmacieSSO', getDigipharmacieSSODetails],
	['finthesis', getFinthesisDetails],
	['finthesisSSO', getFinthesisSSODetails],
	['meg', getMegDetails],
	['megSSO', getMegSSODetails],
	['mySilae', getMySilaeDetails],
	['n2f', getN2fDetails],
	['silae', getSilaeDetails],
	['silaeSSO', getSilaeSSODetails],
	['yooz', getYoozDetails],
]);

export const getAppDetails = (application: WidgetExternalApplicationType) => {
	const { type = 'generic' } = application;

	return appTypeDetailsFunctionMapper.get(type) ?? null;
};
